import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";

import Aos from "aos";
import Dashboard from "./screens/Dashboard";
import Toast from "./components/Notifications/Toast";
import Payments from "./screens/Payments/Payments";
import Appointments from "./screens/Appointments";
import Patients from "./screens/Patients/Staff";
import Campaings from "./screens/Campaings";
import Services from "./screens/ServicesBeauty";
import Invoices from "./screens/Invoices/Invoices";
import Settings from "./screens/Settings";
import CreateInvoice from "./screens/Invoices/CreateInvoice";
import EditInvoice from "./screens/Invoices/EditInvoice";
import PreviewInvoice from "./screens/Invoices/PreviewInvoice";
import EditPayment from "./screens/Payments/EditPayment";
import PreviewPayment from "./screens/Payments/PreviewPayment";
import Medicine from "./screens/Medicine";
import PatientProfile from "./screens/Patients/StaffProfile";
import CreatePatient from "./screens/Patients/CreatePatient";
import Doctors from "./screens/Doctors/Doctors";
import DoctorProfile from "./screens/Doctors/DoctorProfile";
import Receptions from "./screens/Receptions";
import NewMedicalRecode from "./screens/Patients/NewMedicalRecode";
import NotFound from "./screens/NotFound";
import Login from "./screens/Login";
import AuthModal from "./components/AuthModal/AuthModal";
import PrivateRoute from "./PrivateRoute";
import ServicesNails from "./screens/ServicesNails";
import ServicesBeauty from "./screens/ServicesBeauty";
import Staff from "./screens/Patients/Staff";
import StaffProfile from "./screens/Patients/StaffProfile";
import AppointmentDetail from "./screens/AppointmentDetail";
import CustomerDetail from "./screens/Customer/CustomerDetail";
import DetailBooking from "./screens/DetailBooking/DetailBooking";
import ListofCustomers from "./screens/Customer/ListofCustomers";
import ListofBooking from "./screens/DetailBooking/ListofBooking";
import WalkInBooking from "./screens/WalkInBooking/WalkInBooking";
import BookingModify from "./screens/WalkInBooking/BookingModify";
import { Navigate } from "react-router-dom"; // Add this at top of App.js
import BusinessIntroPage from "./screens/Intro/BusinessIntroPage";
import "react-modal-video/css/modal-video.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "aos/dist/aos.css";
import { useEffect } from "react";
import About from "./screens/Intro/About";
import Contact from "./screens/Intro/Contact";
import Register from "./screens/RegisterBusiness/Register";
import IntroLayout from "./screens/Intro/IntroLayout";
import RequestCall from "./screens/Intro/contactComponent/BookACall";
import HelpCenter from "./screens/Intro/HelpCenter";
import Nails from "./screens/Industry/Nails";
import Beauty from "./screens/Industry/Beauty";
import Barber from "./screens/Industry/Barber";
import SpaMassage from "./screens/Industry/SpaMassage";
import Restaurant from "./screens/Industry/Restaurant";
import NightMarket from "./screens/Industry/NightMarket";
import Price from "./screens/Price/Price";
import PriceBooking from "./screens/Price/PriceBooking";
import PriceOrdering from "./screens/Price/PriceOrdering";
import SectionExpiredModal from "./components/SectionExpiredModal/SectionExpiredModal";
import { useSelector } from "react-redux";
import OrdersCalendar from "./screens/Ordering/OrdersCalendar";
import LoyaltyWalletMainPage from "./screens/LoyaltyWallet/LoyaltyWalletMainPage";
import VerifyEmailPage from "./components/AuthModal/VerifyEmailForm";
import BookingServices from "./screens/BookingServices/BookingServices";
import SingleService from "./screens/BookingServices/SingleService";
import BundleService from "./screens/BookingServices/BundleService";
import AddNewStaff from "./screens/Staff/AddNewStaff";
import EditService from "./screens/BookingServices/EditService";
import OrderingRoutes from "./routes/OrderingRoutes";
import LoyaltyRoutes from "./routes/LoyaltyRoutes";
import Category from "./screens/menu/category/Category";
import Products from "./screens/e-commerce/products/Products";
import Orders from "screens/e-commerce/orders/Orders";
import Order from "screens/e-commerce/order/Order";

function App() {
  useEffect(() => {
    Aos.init({ once: true });
  }, []);

  const user = useSelector((state) => state.user.user);

  console.log("operatorType from user:", user?.operatorType);

  const getDefaultRoute = () => {
    if (!user?.operatorType) return "/intro"; // fallback
    switch (user.operatorType) {
      case "ordering":
        return "/orderscalendar";
      case "booking":
        return "/appointments";
      case "loyalty-only":
        return "/loyaltywallet"; // or maybe /loyalty if you create it
      default:
        return "/";
    }
  };

  return (
    <>
      <Toast />
      <BrowserRouter>
        <AuthModal />

        <SectionExpiredModal />

        <Routes>
          {/* Public Routes */}
          <Route element={<IntroLayout />}>
            <Route path="/intro" element={<BusinessIntroPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/price" element={<Price />} />

            <Route path="/price/price-booking" element={<PriceBooking />} />
            <Route path="/price/price-ordering" element={<PriceOrdering />} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/contact/book-a-call" element={<RequestCall />} />
            <Route path="/help-center" element={<HelpCenter />} />

            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />

            {/* For Your Industry routes */}
            <Route path="/industry/beauty" element={<Beauty />} />
            <Route path="/industry/nails" element={<Nails />} />
            <Route path="/industry/barbers" element={<Barber />} />
            <Route path="/industry/spa" element={<SpaMassage />} />
            <Route path="/industry/massages" element={<SpaMassage />} />
            {/* <Route path="/industry/tattoo" element={<Tattoo />} /> */}
            <Route path="/industry/restaurants" element={<Restaurant />} />
            <Route path="/industry/takeaway" element={<Restaurant />} />
            <Route path="/industry/night-market" element={<NightMarket />} />
            {/* <Route path="/industry/gym" element={<Gym />} /> */}
            {/* <Route path="/industry/pet-care" element={<PetCare />} /> */}
            {/* <Route path="/industry/car-wash" element={<CarWash />} /> */}
            <Route path="/industry/night-market" element={<NightMarket />} />

            <Route path="/verify-otp" element={<VerifyEmailPage />} />
          </Route>

          {/* Private Routes */}
          <Route element={<PrivateRoute />}>
            {/* <Route path="/" element={<Navigate to="/appointments" replace />} /> */}

            <Route
              path="/"
              element={<Navigate to={getDefaultRoute()} replace />}
            />

            <Route path="/dashboard" element={<Dashboard />} />
            {/* invoce */}
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/invoices/create" element={<CreateInvoice />} />
            <Route path="/invoices/edit/:id" element={<EditInvoice />} />
            <Route path="/invoices/preview/:id" element={<PreviewInvoice />} />
            {/* payments */}
            <Route path="/payments" element={<Payments />} />
            <Route path="/payments/edit/:id" element={<EditPayment />} />
            <Route path="/payments/preview/:id" element={<PreviewPayment />} />
            {/* patient */}
            <Route path="/staffs" element={<Staff />} />
            <Route path="/staff/preview/:id" element={<StaffProfile />} />

            <Route path="/staff/create" element={<CreatePatient />} />
            <Route path="/staff/addnewstaff" element={<AddNewStaff />} />
            <Route path="/staff/visiting/:id" element={<NewMedicalRecode />} />
            {/* customer */}
            <Route path="/customer/preview/:id" element={<CustomerDetail />} />

            <Route path="/customers" element={<ListofCustomers />} />

            {/* booking */}
            <Route path="/listofbooking" element={<ListofBooking />} />
            <Route path="/booking/preview/:id" element={<DetailBooking />} />
            <Route path="/booking/reschedule/:id" element={<BookingModify />} />

            <Route path="/book/create" element={<WalkInBooking />} />

            {/* doctors */}
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/doctors/preview/:id" element={<DoctorProfile />} />
            {/* reception */}
            <Route path="/receptions" element={<Receptions />} />
            {/* others */}
            <Route path="/appointments" element={<Appointments />} />
            <Route path="/appointments/:id" element={<AppointmentDetail />} />
            <Route path="/campaigns" element={<Campaings />} />
            <Route path="/medicine" element={<Medicine />} />
            <Route path="/nailservices" element={<ServicesNails />} />
            <Route path="/beautyservices" element={<ServicesBeauty />} />

            {/* booking services */}
            <Route path="/bookingservices" element={<BookingServices />} />
            <Route
              path="/bookingservices/service/add/new"
              element={<SingleService />}
            />
            <Route
              path="/bookingservices/service/edit/:id"
              element={<EditService />}
            />
            <Route
              path="/bookingservices/package/add/new"
              element={<BundleService />}
            />

            {/* order section */}
            <Route path="/orderscalendar" element={<OrdersCalendar />} />
            <Route path="/ordering/menu-category" element={<Category />} />
            <Route path="/apps/e-commerce/products" element={<Products />} />
            <Route path="/apps/e-commerce/orders" element={<Orders />} />
            <Route
              path="/apps/e-commerce/orders/:orderID"
              element={<Order />}
            />

            {/* loyalty only */}
            <Route path="/loyaltywallet" element={<LoyaltyWalletMainPage />} />

            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
